import styled from 'react-emotion';
import { switcher } from 'utilities';

const Flex = styled('div')`
  display: flex;
  align-items: ${props => switcher(props.align, {
    baseline: 'baseline',
    center: 'center',
    undefined: ''
  })};
  ${props => props.justifyContent ? `
    justify-content: ${props.justifyContent};
  ` : null}
  > * + * {
    padding-left: ${props => props.padding || 0}px;
  }
`;

export default Flex;


// WEBPACK FOOTER //
// ./src/components/ui/Flex.jsx